import { lazy, Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Loader from "../components/common/CommonFallBackLoader";
import GlobalErrorBoundary from "../components/common/GlobalErrorComponent";
import ErrorFallback from "../components/common/ErrorFallBackComponent";
import PrivateRoute from "../components/PrivateRoute";
import { PERMISSIONS } from "../auth/permission-config";

const ReleaseComponentContainer = lazy(() =>
  import("../components/ReleaseComponentSummary/ReleaseComponentContainer")
);
const ReportsContainer = lazy(() =>
  import("../components/Reports/ReportComponent")
);
const ReportsDashboardComponent = lazy(() =>
  import("../components/Reports/ReportsDashboardComponent")
);
const UserManagement = lazy(() =>
  import("../components/UserManagement/UserManagementComponent")
);
const AuditLogContainer = lazy(() =>
  import("../components/AuditLog/AuditLogContainer")
);

const BodyContainer = () => {
  const location = useLocation();

  return (
    <section>
      <GlobalErrorBoundary key={location.pathname} FallbackComponent={ErrorFallback}>
        <Suspense fallback={<Loader height="100vh" />}>
          <Routes>
            <Route path="/" element={<ReleaseComponentContainer />} />
            <Route path="/release-component-summary" element={<ReleaseComponentContainer />} />
            <Route path="/reports" element={<ReportsContainer />} />
            <Route path="/reports/reports-dashboard" element={<ReportsDashboardComponent />} />
            <Route
              path="/user-management"
              element={
                <PrivateRoute requiredPermissions={[PERMISSIONS.UM_VIEW]}>
                  <UserManagement />
                </PrivateRoute>
              }
            />
            <Route path="/audit-log" element={<AuditLogContainer />} />
            <Route path="*" element={<ReleaseComponentContainer />} />
          </Routes>
        </Suspense>
      </GlobalErrorBoundary>
    </section>
  );
};

export default BodyContainer;
